'use client';
import { useTranslations } from 'next-intl';
export function Trans({
  i18nKey,
  values,
  defaults,
}: {
  i18nKey: string;
  values?: Record<string, string | number | Date>;
  defaults?: string;
}) {
  const t = useTranslations();
  return <>{defaults && !t.has(i18nKey) ? defaults : t(i18nKey, values)}</>;
}
